import AnomalyPhraseCountsChart from "pages/anomaly/anomaly-phrase-counts-chart";
import InteractionsTable from "components-for/interactions/interactions-table";
import InteractionsTableDateTimeColumn from "components-for/interactions/interactions-table-date-time-column";
import InteractionsTableMessageColumn from "components-for/interactions/interactions-table-message-column";
import InteractionsTableMetricsColumn from "components-for/interactions/interactions-table-metrics-column";
import InteractionsTableSentimentColumn from "components-for/interactions/interactions-table-sentiment-column";
import MetricsOverTimeCharts from "components-for/metrics/metrics-over-time-charts";
import { Box } from "@edgetier/client-components";
import { FunctionComponent, memo, useMemo } from "react";
import { IProps } from "./explore-results.types";
import { useQueryParameters } from "@edgetier/client-components";
import { parseISO } from "date-fns";
import { InteractionMetric } from "@edgetier/watchtower-types";
import { EXPERIENCE_SCORE_METRIC_ENABLED } from "constants/feature-flags";
import "./explore-results.scss";

/**
 * Take search parameters from the URL and call the backend with them to show a chart and table.
 * @returns Chart and table.
 */
const ExploreResults: FunctionComponent<IProps> = () => {
    const dateTime = useMemo(() => new Date(), []);
    const { endDateTime, startDateTime } = useQueryParameters({ endDateTime: parseISO, startDateTime: parseISO });

    const interactionMetricExcludeOptions = [
        ...(EXPERIENCE_SCORE_METRIC_ENABLED ? [] : [InteractionMetric.ExperienceScore]),
    ];
    return (
        <div className="explore-results">
            <Box>
                <AnomalyPhraseCountsChart
                    anomalyEndDateTime={endDateTime}
                    anomalyStartDateTime={startDateTime}
                    dateTime={dateTime}
                    filterRange={false}
                    highlightRange={false}
                    showInteractionsTotal
                />
            </Box>

            <MetricsOverTimeCharts
                defaultEndDateTime={endDateTime}
                defaultStartDateTime={startDateTime}
                excludedInteractionMetrics={interactionMetricExcludeOptions}
            />

            <InteractionsTable
                defaultParameters={{
                    endDateTime: startDateTime,
                    startDateTime: endDateTime,
                }}
                title="Relevant Interactions"
            >
                <InteractionsTableDateTimeColumn />
                <InteractionsTableMessageColumn />
                <InteractionsTableSentimentColumn />
                <InteractionsTableMetricsColumn />
            </InteractionsTable>
        </div>
    );
};

export default memo(ExploreResults);
